import { isValidDate } from '../validation';
import { IDate } from '../../types';

export const validateDate = (dateValue: IDate): string => {
  const { YYYY, DD, MM } = dateValue;
  if (YYYY && DD && MM) {
    const isValid = isValidDate(dateValue);
    if (!isValid) {
      return "Doesn't look like a valid date";
    }
  }
  return '';
};
